import { createTheme } from "@mui/material/styles";

const typography = {
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"SF Pro Text"',
    '"Segoe UI"',
    "Roboto",
    "Helvetica Neue",
    "Arial",
    "sans-serif",
  ].join(","),
  h5: { fontWeight: 600, letterSpacing: "-0.02em" },
  h6: { fontWeight: 600, letterSpacing: "-0.01em" },
  button: { textTransform: "none", fontWeight: 600 },
};

/**
 * @param {"light" | "dark"} mode
 */
export function createAppTheme(mode) {
  const isDark = mode === "dark";
  return createTheme({
    palette: {
      mode,
      primary: {
        main: "#2d6a4f",
      },
      secondary: {
        main: isDark ? "#81c784" : "#4caf50",
      },
      background: {
        default: isDark ? "rgba(18, 24, 22, 0.97)" : "rgba(255, 255, 255, 0)",
        paper: isDark ? "rgba(32, 40, 36, 0.88)" : "rgba(255, 255, 255, 0.55)",
      },
      text: {
        primary: isDark ? "rgba(255, 255, 255, 0.92)" : "rgba(0, 0, 0, 0.88)",
        secondary: isDark ? "rgba(255, 255, 255, 0.62)" : "rgba(0, 0, 0, 0.55)",
      },
    },
    typography,
    shape: {
      borderRadius: 16,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 14,
            padding: "10px 22px",
            boxShadow: "none",
          },
          contained: {
            background: isDark
              ? "linear-gradient(180deg, rgba(255,255,255,0.14) 0%, transparent 100%), #2d6a4f"
              : "linear-gradient(180deg, rgba(255,255,255,0.22) 0%, transparent 100%), #2d6a4f",
            boxShadow: isDark
              ? "0 4px 18px rgba(0, 0, 0, 0.45)"
              : "0 4px 14px rgba(45, 106, 79, 0.35)",
            "&:hover": {
              boxShadow: isDark
                ? "0 6px 22px rgba(0, 0, 0, 0.55)"
                : "0 6px 20px rgba(45, 106, 79, 0.42)",
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: isDark
            ? {
                borderRadius: 20,
                backgroundColor: "rgba(36, 44, 40, 0.72)",
                backdropFilter: "blur(24px) saturate(180%)",
                WebkitBackdropFilter: "blur(24px) saturate(180%)",
                border: "1px solid rgba(255, 255, 255, 0.12)",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.06)",
              }
            : {
                borderRadius: 20,
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                backdropFilter: "blur(24px) saturate(180%)",
                WebkitBackdropFilter: "blur(24px) saturate(180%)",
                border: "1px solid rgba(255, 255, 255, 0.65)",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
              },
        },
      },
    },
  });
}

export default createAppTheme("light");
